import React, { Component } from "react";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import "./index.css";

class SocialTwitterWidget extends Component {
  render() {
    return (
      <div className="row mt-4">
        <div className="col irc-logs-col">
          <div
            className="twitter-col  p-3"
            style={{
              background: "var(--cardBg)",
              border: "var(--card-border)",
              transition: "color 0.2s ease-out, background 0.2s ease-out"
            }}
          >
            <div className="market-inner-col d-flex justify-content-between mb-3">
              <span className="badge badge-warning market-bedge">
                SOCIAL Twitter
              </span>
              <img
                className="img-fluid"
                src={require("../../assets/icons/share-icon.svg")}
                alt="share"
              />
            </div>
            <div className="row pl-2 pr-2">
              <div className="col-2 p-0">
                <img
                  className="img-fluid"
                  src={require("../../assets/twitter-user.png")}
                  alt="twitter-user"
                />
              </div>

              <div className="col-10 p-0">
                <p
                  className="m-0 twitter-name"
                  style={{
                    color: "var(--pDescColor)",
                    transition:
                      "color 0.2s ease-out 0s, background 0.2s ease-out 0s"
                  }}
                >
                  Tau-Chain
                </p>
                <p
                  className="m-0 twitter-username"
                  style={{
                    color: "var(--pColor)",
                    transition:
                      "color 0.2s ease-out 0s, background 0.2s ease-out 0s"
                  }}
                >
                  @TauChainOrg
                </p>
                <p
                  className="twitter-post-desc mt-3"
                  style={{
                    color: "var(--pDescColor)",
                    transition:
                      "color 0.2s ease-out 0s, background 0.2s ease-out 0s"
                  }}
                >
                  Tau Chain September Update and QandA Video is Out!
                  <br />
                  <span className="twitter-link">youtu.be/jpLhuKjkS4</span>
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col text-center">
                <img
                  className="img-fluid"
                  src={require("../../assets/twitter-post.png")}
                  alt=""
                />
              </div>
            </div>

            {/* <div className="twitter-embed">
              <TwitterTimelineEmbed
                sourceType="profile"
                screenName="tauchainorg"
                options={{
                  tweetLimit: "1",
                  width: "100%",
                  height: "100%"
                }}
                theme="dark"
                noHeader="true"
                noBorders="true"
                noFooter="true"
              ></TwitterTimelineEmbed>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default SocialTwitterWidget;
